/* Prime Phones — app-like page changes for the bottom bar (owner, 23 Oct 2026: "like an actual app…
   the web page is reloading. That can't be happening"). Phones only (under 990px); loaded by
   sections/pp-bottom-bar.liquid when its "App-like page changes" setting is on.

   - The bar's pages (Home, Shop, Pay later; not the cart) are downloaded into memory when the browser
     is idle (iPhones ignore <link rel="prefetch">, so the bar fetches them itself). Not on Save-Data or
     2G: there a tap downloads only the page itself, with a thin loading line.
   - A tap swaps only the page's main content in place: no reload; the header, the bar, the chat and
     the app widgets stay. The new content glides in from the side tapped. The address, the title, the
     description, the header's "current page" marks, the stock-alert return address and the chat's page
     context follow; back and forward work, and each page keeps its scroll position.
   - Fresh stock: a page shown from memory is downloaded again straight away; a section whose text or
     products changed (a phone sold, added or repriced) is replaced in place, keeping the scroll.
   - Safe by design: a tap loads the page the ordinary way when the new page holds a script that has
     not been tested here (a new section or app), when the theme has been updated since this page
     loaded, when a style sheet does not arrive, or when the download fails or takes over 8 s. After a
     swap, an error from the theme's code or an element whose code never started reloads the page once.
   - Shopify counts a page view only on a full page load. Each swap publishes the custom event
     "pp_page_view" (Shopify.analytics.publish), which a custom pixel can forward as a page view.
   The back/forward listener sits in snippets/pp-view-transitions.liquid (in <head>), so it runs before
   the theme's filter script, which would otherwise redraw the collection grid on another page. */
(function () {
  'use strict';
  if (window.PPAppNav) return;

  var phone = window.matchMedia('(max-width: 989.98px)');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var html = document.documentElement;
  var FRESH = 60000;          /* a copy younger than this is not downloaded again before use */
  var KEEP = 600000;          /* older than this, a tap waits for the network instead */
  var WAIT = 8000;            /* longer than this, the ordinary page load takes over */
  /* scripts that are known to start again correctly after a swap (each guards against running twice
     and starts its sections on "shopify:section:load"); any other script means an ordinary load */
  var KNOWN = ['pp-bento.js', 'pp-reviews.js', 'pp-collection.js', 'facets.js', 'product-form.js', 'quantity-popover.js', 'pp-eta.js', 'pp-cashback.js', 'pp-video-reviews.js'];
  /* elements the theme never defines, even on an ordinary load (measured 23 Oct 2026 on all four pages) */
  var NEVER = ['INFINITE-SCROLL'];

  var LIMIT = 24;             /* pages kept in memory at most (the oldest go first) */
  var BUDGET = 6;             /* pages fetched ahead per page shown, from what is on screen */

  var pages = [];             /* [{ path, key, i, cart }] the bar's pages: path, address to preload, place */
  var cartAt = 0;             /* when the cart last changed: an older copy of the cart page is not used */
  var cache = {};             /* key → { t, doc } or { p } while downloading */
  var shown = here();
  var turn = 0;
  var ran = {};               /* script files already run in this document */
  var line = null;

  /* ---------- the Back button, like an app (owner, 30 Oct 2026: a tap in the bar must not count as a
     step back) ----------
     Every history entry is numbered by its depth: the first page of the visit is 0. A tap in the bar
     goes back to the visit's first entry and puts Home there, then the tab above it, so Back from any
     tab goes to Home and Back from Home leaves the site; a link inside a page adds a step as usual.
     Entries of this document only (docStart up) can be gone back over without a reload; when the visit
     started in an earlier document, the tab replaces the current entry instead. */
  var depth = 0;
  var docStart = 0;
  var ignore = 0;             /* history moves of our own: the next popstate is not a visitor's Back */
  var landed = null;          /* called by popped() when our own move has arrived */
  function num(k) { try { var v = sessionStorage.getItem(k); return v === null ? null : Number(v); } catch (e) { return null; } }
  /* replacing: the next page takes this entry's place (location.replace), so it is at this depth, not one deeper */
  var replacing = false;
  function saveDepth() { try { sessionStorage.setItem('pp-d', String(replacing ? depth - 1 : depth)); } catch (e) {} }
  (function () {
    var st = history.state;
    if (st && typeof st.d === 'number') depth = st.d;
    else {
      var last = num('pp-d');
      var same = false;
      try { same = !!document.referrer && new URL(document.referrer).origin === location.origin; } catch (e) {}
      depth = same && last !== null && last >= 0 ? last + 1 : 0;
    }
    docStart = depth;
    var push = history.pushState;
    var swapState = history.replaceState;
    var tag = function (s) { return s && typeof s === 'object' ? Object.assign({}, s, { d: depth }) : { d: depth, v: s === undefined ? null : s }; };
    try {
      swapState.call(history, tag(st), '');
      /* every step anyone adds (the filters, the chat) carries its depth too */
      history.pushState = function (s, t, u) { depth++; saveDepth(); return push.call(history, tag(s), t, u); };
      history.replaceState = function (s, t, u) { return swapState.call(history, tag(s), t, u); };
    } catch (e) {}
    saveDepth();
  })();
  /* back over n entries of this document without a reload, unseen (the next page is drawn after) */
  function silentGo(n) {
    return new Promise(function (res) {
      if (!n) { res(); return; }
      ignore++;
      var over = false;
      var done = function () {
        if (over) return;
        over = true;
        clearTimeout(t);
        if (landed === done) landed = null;
        /* the depth of the entry arrived at, before anything is added on top of it */
        var s = history.state;
        if (s && typeof s.d === 'number') depth = s.d;
        setTimeout(function () { ignore = Math.max(0, ignore - 1); }, 0);
        res();
      };
      var t = setTimeout(done, 700);
      /* told by popped() (the head's popstate listener stops the event for everyone else) */
      landed = done;
      history.go(-n);
    });
  }
  /* a tab tapped: Home at the visit's first entry, the tab above it (or the tab in place of the entry
     shown, when the visit began in an earlier document) */
  function rebase(url, home, homeY) {
    var steps = depth - docStart;
    return silentGo(steps).then(function () {
      if (docStart === 0 && home && key(home) !== key(url)) {
        history.replaceState({ ppan: 1, ppY: homeY || 0 }, '', home);
        history.pushState({ ppan: 1 }, '', url);
      } else {
        history.replaceState({ ppan: 1 }, '', url);
      }
      saveDepth();
    });
  }

  function norm(p) { return (p || '/').replace(/\/+$/, '') || '/'; }
  function strip(u) {
    var a = new URL(u, location.href);
    ['preview_theme_id', 'pb', '_pos', '_sid', '_ss'].forEach(function (k) { a.searchParams.delete(k); });
    return a;
  }
  function key(u) { var a = strip(u); return norm(a.pathname) + a.search; }
  function here() { return key(location.href); }
  function file(src) { try { return new URL(src, location.href).pathname.split('/').pop(); } catch (e) { return ''; } }
  function abs(h) { try { var u = new URL(h, location.href); return u.host + u.pathname; } catch (e) { return h; } }
  function page(u) {
    var p = norm(strip(u).pathname);
    for (var i = 0; i < pages.length; i++) if (pages[i].path === p) return pages[i];
    return null;
  }
  function frugal() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /2g/.test(c.effectiveType || '')));
  }

  /* Pages that change in place: the bar's, the home page, every collection and every content page.
     Product pages always load the ordinary way, so Shopify, Google and Meta still see every product
     view (a swap is not a page load); they are fetched ahead instead (speculate below). */
  var SWAP = /^\/(collections(\/[\w-]+)?|pages\/[\w-]+)$/;
  function eligible(u) {
    var a;
    try { a = new URL(u, location.href); } catch (e) { return false; }
    if (a.origin !== location.origin || a.hash) return false;
    if (a.searchParams.has('view') || a.searchParams.has('section_id')) return false;
    var p = norm(a.pathname);
    return !!page(u) || p === '/' || SWAP.test(p);
  }
  function product(u) {
    try { var a = new URL(u, location.href); return a.origin === location.origin && /^\/products\/[\w-]+\/?$/.test(a.pathname); } catch (e) { return false; }
  }

  /* Android's Chrome (and other Chromium phones) downloads a product page ahead without running it, and
     uses that copy when the link is opened: a real page load, from memory. */
  var specOk = !!(window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'));
  var specd = {};
  function speculate(u) {
    if (!specOk || frugal()) return;
    var a = strip(u);
    var h = a.pathname + a.search;
    if (specd[h]) return;
    specd[h] = 1;
    var s = document.createElement('script');
    s.type = 'speculationrules';
    s.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: [h] }] });
    document.head.appendChild(s);
  }

  /* fetched ahead: a page about to be opened (a finger on its link) or one whose link has been on screen
     a moment (at most BUDGET per page shown, never on Save-Data or 2G) */
  function ahead(u) {
    if (product(u)) { speculate(u); return; }
    if (!eligible(u) || healed || !phone.matches) return;
    var k = key(u);
    var c = cache[k];
    if (c && (c.p || Date.now() - c.t < FRESH)) return;
    load(k, true).then(function (e) { later(e, warm); }, function () {});
  }
  var watcher = null;
  var budget = BUDGET;
  function scout(root) {
    if (watcher) watcher.disconnect();
    budget = BUDGET;
    if (frugal() || !('IntersectionObserver' in window) || !phone.matches) return;
    var seen = {};
    watcher = new IntersectionObserver(function (list) {
      list.forEach(function (x) {
        var a = x.target;
        clearTimeout(a.__ppAhead);
        if (!x.isIntersecting) return;
        a.__ppAhead = setTimeout(function () {
          if (budget <= 0 || !watcher) return;
          budget--;
          watcher.unobserve(a);
          ahead(a.href);
        }, 700);
      });
    }, { threshold: 0.6 });
    (root || document).querySelectorAll('#MainContent a[href*="/products/"]').forEach(function (a) {
      var h = a.getAttribute('href').split('#')[0];
      if (seen[h]) return;
      seen[h] = 1;
      watcher.observe(a);
    });
  }

  /* a link in the page: in place when it can be, otherwise an ordinary load that answers at once */
  function linkOf(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return null;
    /* the bar handles its own taps; the chat, pop-ups and the stock-alert forms keep theirs */
    if (a.closest('[data-ppbb], .ppk-root, .pp-pop, [data-no-swap]')) return null;
    return a;
  }
  document.addEventListener('pointerdown', function (e) {
    if (!phone.matches || e.button > 0) return;
    var a = linkOf(e);
    if (a) ahead(a.href);
  }, { passive: true, capture: true });
  /* registered on window: the page's own click handlers (pop-ups, quick add) run first and can claim it */
  window.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || !phone.matches) return;
    var a = linkOf(e);
    if (!a) return;
    var u = a.href;
    if (key(u) === here() && !strip(u).hash) return;
    if (eligible(u) && !healed && go(u, 'next', false, 0)) { e.preventDefault(); return; }
    /* an ordinary load (a product page): the page answers at once and the next one glides in */
    if (product(u) && !still.matches && look().style === 'slide') {
      try { sessionStorage.setItem('pp-vt', JSON.stringify({ d: 'next', t: Date.now() })); } catch (x) {}
      html.classList.add('pp-leave-next');
      setTimeout(function () { html.classList.remove('pp-leave-next'); }, 6000);
    }
  });

  /* menus and drawers open when the page changes in place are closed first */
  function closeOverlays() {
    var hd = document.querySelector('header-drawer');
    if (hd && hd.querySelector('details[open]') && typeof hd.closeMenuDrawer === 'function') { try { hd.closeMenuDrawer(new Event('click')); } catch (e) {} }
    document.querySelectorAll('details-modal').forEach(function (m) { if (m.isOpen && typeof m.close === 'function') { try { m.close(); } catch (e) {} } });
    var cd = document.querySelector('cart-drawer.active');
    if (cd && typeof cd.close === 'function') { try { cd.close(); } catch (e) {} }
  }

  document.querySelectorAll('script[src]').forEach(function (s) { ran[abs(s.src)] = 1; });

  /* ---------- downloads ---------- */
  /* A downloaded page is read (parsed) only when the phone is idle, never while a finger is on the screen
     (reading a page holds the phone for 50–300 ms, and a tap waited behind it); a tap that needs a page not
     read yet reads it at once. */
  function parse(text) {
    var doc = new DOMParser().parseFromString(text, 'text/html');
    if (!doc.getElementById('MainContent')) throw new Error('main');
    return doc;
  }
  function ready(entry) {
    if (entry && !entry.doc && entry.text) { entry.doc = parse(entry.text); entry.text = null; }
    return entry;
  }
  var idle = window.requestIdleCallback ? function (fn) { requestIdleCallback(fn, { timeout: 3000 }); } : function (fn) { setTimeout(fn, 300); };
  function later(entry, then) {
    idle(function () {
      try { ready(entry); } catch (e) { return; }
      if (entry.doc && then) then(entry);
    });
  }

  function load(k, force, urgent) {
    var c = cache[k];
    if (!force && c && (c.doc || c.text)) return Promise.resolve(c);
    if (c && c.p) return c.p;
    /* dated from the moment it was asked for: a cart change during the download makes it out of date;
       never the browser's stored copy (the cart page does not say how long it may be kept) */
    var asked = Date.now();
    var to = page(k);
    var p = fetch(k, { credentials: 'same-origin', cache: to && to.cart ? 'no-store' : 'no-cache', headers: { Accept: 'text/html' } })
      .then(function (r) {
        if (!r.ok || r.redirected) throw new Error('status');
        return r.text();
      })
      .then(function (text) {
        var entry = { t: asked, text: text, used: Date.now() };
        if (urgent) ready(entry);
        cache[k] = entry;
        prune();
        return entry;
      });
    cache[k] = { p: p, doc: c && c.doc, text: c && c.text, t: c && c.t };
    p.catch(function () { if (cache[k] && cache[k].p === p) delete cache[k]; });
    return p;
  }

  /* at most LIMIT pages in memory: the longest unused go first (never the bar's pages or the one shown) */
  function prune() {
    var ks = Object.keys(cache).filter(function (k) { return (cache[k].doc || cache[k].text) && !cache[k].p && !page(k) && k !== shown; });
    if (ks.length + pages.length <= LIMIT) return;
    ks.sort(function (a, b) { return (cache[a].used || cache[a].t) - (cache[b].used || cache[b].t); });
    ks.slice(0, ks.length + pages.length - LIMIT).forEach(function (k) { delete cache[k]; });
  }

  /* when the browser is idle: every bar page, the current one too (for going back to it) */
  function preload() {
    if (frugal()) return;
    var go = function () {
      var keys = pages.map(function (x) { return x.key; });
      if (page(location.href)) keys.push(here());
      keys.forEach(function (k, n) {
        setTimeout(function () {
          var c = cache[k];
          if (c && (c.p || Date.now() - c.t < FRESH)) return;
          load(k, true).then(function (e) { later(e, warm); }, function () {});
        }, n * 400);
      });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 4000 });
    else setTimeout(go, 2500);
  }

  /* styles, code and the first pictures of a downloaded page, so it shows complete and starts at once */
  function warm(entry) {
    var doc = entry.doc;
    var have = sheets();
    doc.querySelectorAll('#MainContent script[src]').forEach(function (s) {
      var h = s.getAttribute('src');
      if (ran[abs(h)] || KNOWN.indexOf(file(h)) < 0 || document.querySelector('link[rel="preload"][href="' + h + '"]')) return;
      var l = document.createElement('link');
      l.rel = 'preload';
      l.as = 'script';
      l.href = h;
      document.head.appendChild(l);
    });
    doc.querySelectorAll('link[rel="stylesheet"]').forEach(function (l) {
      var h = l.getAttribute('href');
      if (!h || have[abs(h)] || cssQueue.indexOf(h) > -1) return;
      cssQueue.push(h);
    });
    applyCss();
    var n = 0;
    doc.querySelectorAll('#MainContent img').forEach(function (im) {
      if (n >= 4 || im.getAttribute('loading') === 'lazy') return;
      n++;
      var i = new Image();
      if (im.getAttribute('sizes')) i.sizes = im.getAttribute('sizes');
      if (im.getAttribute('srcset')) i.srcset = im.getAttribute('srcset');
      i.src = im.getAttribute('src') || '';
    });
  }

  /* The next pages' style sheets are switched on ahead, one at a time while the phone is idle: switching
     one on restyles the whole page (about 0.65 s on a slow phone), which at the moment of a tap held the
     change back. They are the same sheets the page keeps after any change. */
  var cssQueue = [];
  var cssBusy = false;
  function applyCss() {
    if (cssBusy || !cssQueue.length) return;
    cssBusy = true;
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 300); };
    idle(function () {
      cssBusy = false;
      var h = cssQueue.shift();
      if (h && !sheets()[abs(h)]) {
        var n = document.createElement('link');
        n.rel = 'stylesheet';
        n.href = h;
        document.head.appendChild(n);
      }
      applyCss();
    }, { timeout: 4000 });
  }

  function sheets() {
    var s = {};
    document.querySelectorAll('link[rel="stylesheet"]').forEach(function (l) { s[abs(l.href)] = 1; });
    return s;
  }

  /* ---------- is this page safe to swap in? ---------- */
  function safe(doc) {
    /* the same theme and the same version of its code */
    var mine = document.querySelector('script[src*="pp-app-nav.js"]');
    var theirs = doc.querySelector('script[src*="pp-app-nav.js"]');
    if (!mine || !theirs || mine.getAttribute('src') !== theirs.getAttribute('src')) return false;
    var ok = true;
    doc.querySelectorAll('#MainContent script').forEach(function (s) {
      var type = (s.getAttribute('type') || '').toLowerCase();
      if (/json/.test(type)) return;
      var src = s.getAttribute('src');
      if (src) { if (KNOWN.indexOf(file(src)) < 0) ok = false; return; }
      var code = s.textContent;
      /* the cart's Internet Explorer fallback: never needed on a phone */
      if (code.indexOf('function isIE()') > -1) return;
      /* inline code that waits for the page's first load would never start */
      if (code.indexOf('document.currentScript') < 0 || /DOMContentLoaded|addEventListener\(\s*['"]load['"]/.test(code)) ok = false;
    });
    return ok;
  }

  /* missing style sheets go into <head> first; the swap waits for them (2 s at most) */
  function styles(doc) {
    var have = sheets();
    var waits = [];
    doc.querySelectorAll('head link[rel="stylesheet"], #MainContent link[rel="stylesheet"]').forEach(function (l) {
      var h = l.getAttribute('href');
      if (!h || have[abs(h)]) return;
      have[abs(h)] = 1;
      var n = document.createElement('link');
      n.rel = 'stylesheet';
      n.href = h;
      waits.push(new Promise(function (res, rej) { n.onload = res; n.onerror = rej; }));
      document.head.appendChild(n);
    });
    if (!waits.length) return Promise.resolve();
    return Promise.race([
      Promise.all(waits),
      new Promise(function (res, rej) { setTimeout(rej, 2000); })
    ]);
  }

  /* ---------- running the new content's code ---------- */
  function run(list) {
    return list.reduce(function (p, old) {
      return p.then(function () {
        var type = (old.getAttribute('type') || '').toLowerCase();
        if (/json/.test(type) || !old.parentNode) return;
        var src = old.getAttribute('src');
        if (src && ran[abs(src)]) { old.remove(); return; }
        var s = document.createElement('script');
        Array.prototype.forEach.call(old.attributes, function (a) { s.setAttribute(a.name, a.value); });
        if (!src) { s.textContent = old.textContent; old.replaceWith(s); return; }
        ran[abs(src)] = 1;
        return new Promise(function (res) {
          s.async = false;
          s.onload = s.onerror = res;
          setTimeout(res, 5000);
          old.replaceWith(s);
        });
      });
    }, Promise.resolve());
  }

  /* the theme's lazy loader (<lazy-script>) remembers only the files it loaded itself: files already
     running here (the cart drawer loads cart.js with a plain script tag) are added to its list first, or
     they would run twice ('CartItems' has already been declared) */
  function claim(root) {
    /* a file the new content needs that also waits, unrun, in a deferred part of the page (the cart
       drawer's <template class="deferred">): that part is unpacked now, as the theme does when it is
       first used, so the file runs once, from there */
    var needs = {};
    root.querySelectorAll('lazy-script[src], script[src]').forEach(function (l) { needs[abs(l.getAttribute('src'))] = 1; });
    document.querySelectorAll('template.deferred').forEach(function (t) {
      if (root.contains(t) || !t.content || !t.parentNode) return;
      var hit = Array.prototype.some.call(t.content.querySelectorAll('script[src], lazy-script[src]'), function (x) { return needs[abs(x.getAttribute('src'))]; });
      if (hit && typeof window.loadTemplateContent === 'function') { try { window.loadTemplateContent(t.parentNode); } catch (e) {} }
    });
    var here = {};
    document.querySelectorAll('script[src]').forEach(function (s) { here[abs(s.src)] = 1; });
    root.querySelectorAll('lazy-script[src]').forEach(function (l) {
      var h = l.getAttribute('src');
      if (!here[abs(h)] && !ran[abs(h)]) return;
      window.loadedScripts = window.loadedScripts || [];
      if (window.loadedScripts.indexOf(h) < 0) window.loadedScripts.push(h);
    });
  }

  /* each section gets "pp:section:load", which the store's own scripts (pp-bento, pp-reviews, pp-motion,
     pp-collection) answer as they answer the theme editor; not the editor's own "shopify:section:load",
     which some theme parts answer page-wide (the number counter breaks on it). The theme's parts start
     themselves as elements; its page-wide helpers run again (each skips what it has already done). */
  function start(root) {
    var list = root.matches && root.matches('.shopify-section') ? [root] : root.querySelectorAll('.shopify-section');
    Array.prototype.forEach.call(list, function (sec) {
      sec.dispatchEvent(new CustomEvent('pp:section:load', { bubbles: true, detail: { sectionId: sec.id.replace(/^shopify-section-/, '') } }));
    });
    ['renderSelects', 'findTallestHeight', 'makeTablesResponsive', 'renderStickers'].forEach(function (f) {
      if (typeof window[f] === 'function') { try { window[f](); } catch (e) {} }
    });
    if (typeof window.initializeScrollAnimationTrigger === 'function') { try { window.initializeScrollAnimationTrigger(root); } catch (e) {} }
  }

  /* ---------- the rest of the page follows ---------- */
  function follow(doc, url) {
    document.title = doc.title;
    ['meta[name="description"]', 'link[rel="canonical"]', 'meta[property="og:url"]', 'meta[property="og:title"]',
      'meta[property="og:description"]', 'meta[name="twitter:title"]', 'meta[name="twitter:description"]'].forEach(function (sel) {
      var a = document.head.querySelector(sel);
      var b = doc.head.querySelector(sel);
      if (!a || !b) return;
      ['content', 'href'].forEach(function (at) { if (b.hasAttribute(at)) a.setAttribute(at, b.getAttribute(at)); });
    });
    /* the template's classes on <body> (index-template, page-index, …) */
    var isPage = function (c) { return /-template(-suffix)?$/.test(c) || (/^page-/.test(c) && !/^page-is-/.test(c)); };
    Array.prototype.slice.call(document.body.classList).forEach(function (c) { if (isPage(c)) document.body.classList.remove(c); });
    doc.body.classList.forEach(function (c) { if (isPage(c)) document.body.classList.add(c); });
    /* state the old page's own code left on <body> */
    document.body.classList.remove('pp-sticky-on', 'pp-atc-dismissed');
    /* "current page" marks in the header and the quick links */
    document.querySelectorAll('a[id^="HeaderDrawer-"], a[id^="HeaderMenu-"]').forEach(function (a) {
      var b = doc.getElementById(a.id);
      if (!b) return;
      a.className = b.className;
      if (b.hasAttribute('aria-current')) a.setAttribute('aria-current', b.getAttribute('aria-current'));
      else a.removeAttribute('aria-current');
    });
    /* the bar's own marks, as the new page has them (a collection is under Shop) */
    var bb = doc.querySelectorAll('[data-ppbb] .ppbb__item');
    document.querySelectorAll('[data-ppbb] .ppbb__item').forEach(function (a, i) {
      var b = bb[i];
      if (!b) return;
      if (b.hasAttribute('aria-current')) a.setAttribute('aria-current', b.getAttribute('aria-current'));
      else a.removeAttribute('aria-current');
    });
    var ql = doc.querySelectorAll('.pp-ql__link');
    document.querySelectorAll('.pp-ql__link').forEach(function (a, i) {
      var b = ql[i];
      if (!b || b.getAttribute('href') !== a.getAttribute('href')) return;
      if (b.hasAttribute('aria-current')) a.setAttribute('aria-current', b.getAttribute('aria-current'));
      else a.removeAttribute('aria-current');
    });
    /* forms outside the content that return to this page (stock alerts) */
    var rt = doc.querySelectorAll('input[name="return_to"]');
    var mine = Array.prototype.filter.call(document.querySelectorAll('input[name="return_to"]'), function (i) { return !i.closest('#MainContent'); });
    var theirs = Array.prototype.filter.call(rt, function (i) { return !i.closest('#MainContent'); });
    mine.forEach(function (i, n) { if (theirs[n]) i.value = theirs[n].value; });
    /* the chat's idea of the page (snippets/pp-ask-button.liquid listens for "pp:page") */
    var cfgA = document.getElementById('ppask-config');
    var cfgB = doc.getElementById('ppask-config');
    if (cfgA && cfgB) cfgA.textContent = cfgB.textContent;
    /* the theme's filter script remembers the page's starting filters (the address may not have changed yet) */
    var F = window.customElements && customElements.get('facet-filters-form');
    var qs = new URL(url, location.href).search.slice(1);
    if (F) { F.searchParamsInitial = qs; F.searchParamsPrev = qs; }
  }

  /* ---------- after a swap: anything wrong reloads the page once ---------- */
  var watching = 0;
  function guard(main) {
    var until = Date.now() + 2500;
    watching = until;
    var bad = function (e) {
      if (watching !== until || Date.now() > until) return;
      var f = e.filename || '';
      if (!e.message || e.message === 'Script error.' || /ResizeObserver/.test(e.message)) return;
      /* only the theme's own code (its files, or code in the page itself): Shopify's pixels and apps are
         also served from this domain, and their errors are not the swap's */
      if (f && f.indexOf('/cdn/shop/t/') < 0 && f.split('#')[0].split('?')[0] !== location.href.split('#')[0].split('?')[0]) return;
      heal(e.message);
    };
    window.addEventListener('error', bad, true);
    setTimeout(function () { window.removeEventListener('error', bad, true); }, 2600);
    setTimeout(function () {
      if (watching !== until || !main.isConnected) return;
      var dead = Array.prototype.filter.call(main.querySelectorAll(':not(:defined)'), function (el) {
        if (NEVER.indexOf(el.tagName) > -1) return false;
        var r = el.getBoundingClientRect();
        return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
      });
      /* still downloading its code on a slow connection is fine: each gets 8 s to start */
      var tags = dead.map(function (el) { return el.tagName.toLowerCase(); }).filter(function (t, i, all) { return all.indexOf(t) === i; });
      tags.forEach(function (tag) {
        var late = setTimeout(function () {
          if (watching === until && main.isConnected && !customElements.get(tag)) heal('never started on screen: ' + tag);
        }, 8000);
        customElements.whenDefined(tag).then(function () { clearTimeout(late); });
      });
    }, 1500);
  }
  function heal(why) {
    if (watching < 0) return;
    watching = -1;
    try { sessionStorage.setItem('pp-app-healed', JSON.stringify({ t: Date.now(), why: String(why).slice(0, 200), url: location.pathname })); } catch (e) {}
    location.reload();
  }
  /* repaired once in this visit: ordinary page loads from now on */
  var healed = false;
  try { healed = !!sessionStorage.getItem('pp-app-healed'); } catch (e) {}

  /* ---------- the swap ---------- */
  /* the bar's settings for the change: "slide" (both pages move together, as on an iPhone), "fade" or "none" */
  /* "ios" (the default): as on an iPhone, a tab switches at once (a quick fade) and a page opened from a
     link slides in, at the speed set */
  function look(tab) {
    var bar = document.querySelector('[data-ppbb]');
    var style = (bar && bar.getAttribute('data-transition')) || 'ios';
    var ms = parseInt(bar && bar.getAttribute('data-speed'), 10) || 400;
    if (style === 'ios') {
      if (tab) return { style: still.matches ? 'none' : 'fade', ms: 160 };
      style = 'slide';
    }
    if (still.matches) style = 'none';
    return { style: style, ms: Math.max(150, Math.min(900, ms)) };
  }

  /* The page that is leaving stays on screen, fixed where it is, for the length of the change: only its
     sections on screen are kept (nothing else is seen), and it gives up its ids so nothing on the new page
     is mistaken for it. Measured before anything changes (the page is laid out then, so it costs nothing). */
  function measure(old) {
    var vh = window.innerHeight;
    return {
      top: old.getBoundingClientRect().top,
      bg: getComputedStyle(document.body).backgroundColor,
      off: Array.prototype.map.call(old.children, function (c) { var r = c.getBoundingClientRect(); return r.bottom < 0 || r.top > vh; })
    };
  }
  function freeze(old, m) {
    Array.prototype.forEach.call(old.children, function (c, i) { if (m.off[i]) c.style.display = 'none'; });
    old.querySelectorAll('[id]').forEach(function (e) { e.removeAttribute('id'); });
    old.removeAttribute('id');
    old.setAttribute('aria-hidden', 'true');
    old.inert = true;
    old.classList.add('pp-swap-old');
    old.style.top = m.top + 'px';
    /* opaque, in the page colour, so the new page waits unseen underneath */
    old.style.backgroundColor = m.bg;
  }

  /* On a slow phone every restyle of the page costs a lot, so the change is done as: measure the old page,
     then make every change at once (template classes, the old page frozen, the change's classes, the new
     content in, the scroll), then measure the new page once (to fill the screen and to know which of its
     sections to move). */
  /* quiet: no movement (the browser's own swipe back has shown it)
     hist: the Back button's steps for this change, started once the change is moving (the store's
     trackers answer an address change at once, and that work would hold back the first frame); the new
     page's code runs after both */
  function swap(entry, dir, y, quiet, tab, url, hist) {
    var doc = entry.doc;
    var old = document.getElementById('MainContent');
    var how = look(tab);
    var moving = how.style !== 'none' && !quiet;
    /* a tab: never two pages on screen at once; the new one takes the old one's place and fades up */
    var fadeUp = moving && how.style === 'fade';
    if (fadeUp) moving = false;
    /* read while the page is still laid out (free now; after the change it would lay the page out again) */
    var sy = window.scrollY;
    var m = moving ? measure(old) : null;
    var main = document.importNode(doc.getElementById('MainContent'), true);
    main.querySelectorAll('link[rel="stylesheet"]').forEach(function (l) { l.remove(); });
    var scripts = Array.prototype.slice.call(main.querySelectorAll('script'));
    /* opening at the top: sections after the first few are skipped by the browser until the change is
       over (pp-bottom-bar.css .pp-later), so the new page is laid out once, with only what is on screen */
    var later = !y ? Array.prototype.slice.call(main.children, 3) : [];
    later.forEach(function (c) { c.classList.add('pp-later'); });
    claim(main);
    /* every change at once */
    follow(doc, url);
    shown = key(url);
    var cls = moving ? ['pp-swap', 'pp-swap--' + how.style, 'pp-swap--' + (dir === 'back' ? 'back' : dir === 'next' ? 'next' : 'up')] : [];
    if (moving) {
      if (changing) changing();
      html.style.setProperty('--pp-swap-ms', how.ms + 'ms');
      cls.forEach(function (c) { html.classList.add(c); });
      freeze(old, m);
      old.after(main);
    } else {
      if (fadeUp) {
        main.classList.add('pp-fadeup');
        setTimeout(function () { main.classList.remove('pp-fadeup'); }, 400);
      }
      old.replaceWith(main);
    }
    if (sy !== (y || 0) || moving) {
      var root = document.scrollingElement || html;
      var sb = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      window.scrollTo(0, y || 0);
      root.style.scrollBehavior = sb;
    }
    /* then the new page measured once: its sections on screen are the ones that move */
    var vh = window.innerHeight;
    if (moving) {
      var on = Array.prototype.map.call(main.children, function (c) { var r = c.getBoundingClientRect(); return r.bottom > 0 && r.top < vh; });
      Array.prototype.forEach.call(main.children, function (c, i) { if (on[i]) c.classList.add('pp-swap-in'); });
    }
    var histP = null;
    var steps = function () {
      if (!histP) histP = Promise.resolve().then(hist).catch(function () {});
      return histP;
    };
    var finish = function () {
      steps().then(settle);
    };
    var settle = function () {
      later.forEach(function (c) { c.classList.remove('pp-later'); });
      guard(main);
      run(scripts).then(function () { start(main); scout(main); });
      try { main.focus({ preventScroll: true }); } catch (e) {}
      document.dispatchEvent(new CustomEvent('pp:page', { detail: { url: location.href } }));
      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish('pp_page_view', { url: location.href, title: document.title, via: 'bottom-bar' });
        }
      } catch (e) {}
    };
    if (moving) ending(old, main, how, cls, finish, steps);
    else requestAnimationFrame(function () { setTimeout(steps, 0); setTimeout(finish, fadeUp ? 240 : 0); });
  }

  /* The change runs on the compositor (pp-bottom-bar.css: slide = both pages side by side, the new one from
     the side of the tab tapped; fade = one into the other), started a frame after the build. When it ends the
     old page is removed and the new page's code starts. */
  var changing = null;
  function ending(old, main, how, cls, finish, steps) {
    var over = false;
    var done = function () {
      if (over) return;
      over = true;
      changing = null;
      clearTimeout(t);
      cls.forEach(function (c) { html.classList.remove(c); });
      html.style.removeProperty('--pp-swap-ms');
      Array.prototype.forEach.call(main.querySelectorAll(':scope > .pp-swap-in'), function (c) { c.classList.remove('pp-swap-in'); });
      if (old.parentNode) old.remove();
      requestAnimationFrame(function () { setTimeout(finish, 0); });
    };
    changing = done;
    /* step 2 after a drawn frame: the change itself */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (over) return;
        html.classList.add('pp-swap--go');
        cls.push('pp-swap--go');
        t = setTimeout(done, how.ms + 150);
        /* the change is moving on its own now: the Back button's steps meanwhile */
        setTimeout(steps, 0);
      });
    });
    old.addEventListener('transitionend', function (e) { if (e.target === old) done(); });
    var t = setTimeout(done, how.ms + 1500);
  }

  /* a thin line under the top of the screen while a page downloads */
  function waiting(on, dir) {
    if (on) {
      html.classList.add('pp-leave-' + dir);
      if (!line) { line = document.createElement('div'); line.className = 'pp-app-line'; line.setAttribute('aria-hidden', 'true'); document.body.appendChild(line); }
      line.classList.add('is-on');
    } else {
      html.classList.remove('pp-leave-next', 'pp-leave-back', 'pp-leave-up');
      if (line) line.classList.remove('is-on');
    }
  }

  /* ---------- fresh stock: compare the page shown with a new download, section by section ---------- */
  function print(sec) {
    var hrefs = Array.prototype.map.call(sec.querySelectorAll('a[href*="/products/"]'), function (a) { return a.getAttribute('href').split('?')[0]; });
    return sec.textContent.replace(/\s+/g, ' ').trim() + '|' + hrefs.join(',');
  }
  function refresh(k, shownEntry) {
    load(k, true).then(function (fresh) { later(fresh, function (entry) {
      if (here() !== k) return;
      if (!safe(entry.doc)) return;
      var main = document.getElementById('MainContent');
      var before = shownEntry.doc;
      entry.doc.querySelectorAll('#MainContent .shopify-section').forEach(function (fresh) {
        var was = before.getElementById(fresh.id);
        var live = document.getElementById(fresh.id);
        if (!was || !live || !main.contains(live) || print(was) === print(fresh)) return;
        /* not while someone is using it (typing, a filter open) */
        if (live.contains(document.activeElement) || live.querySelector('details[open], [aria-expanded="true"]')) return;
        var top = live.getBoundingClientRect().top;
        var h0 = live.offsetHeight;
        var sec = document.importNode(fresh, true);
        sec.querySelectorAll('link[rel="stylesheet"]').forEach(function (l) { l.remove(); });
        var scripts = Array.prototype.slice.call(sec.querySelectorAll('script'));
        claim(sec);
        live.replaceWith(sec);
        if (top < 0) window.scrollBy(0, sec.offsetHeight - h0);
        run(scripts).then(function () { start(sec); });
      });
    }); }, function () {});
  }

  /* ---------- go ---------- */
  /* y: where to scroll the new page to (a tab remembers its place); a back/forward uses its own */
  /* opts.tab: a tap in the bar (Home at the first entry, the tab above it; opts.home, opts.homeY) */
  function go(url, dir, pop, y, opts) {
    opts = opts || {};
    if (healed || !phone.matches || !eligible(url)) return false;
    var k = key(url);
    var my = ++turn;
    if (!pop) {
      try {
        history.scrollRestoration = 'manual';
        history.replaceState(Object.assign({}, history.state, { ppY: window.scrollY }), '');
      } catch (e) {}
    }
    if (pop) y = history.state && history.state.ppY ? history.state.ppY : 0;
    var c = cache[k];
    var to = page(url);
    /* the cart is shown from memory only when nothing has changed in it since it was downloaded */
    var isCart = !!(to && to.cart);
    var instant = c && (c.doc || c.text) && Date.now() - c.t < (isCart ? FRESH : KEEP) && (!isCart || c.t > cartAt);
    var slow = setTimeout(function () { if (my === turn) waiting(true, dir); }, 150);
    var give = setTimeout(function () { if (my === turn) fallback(url, pop, opts); }, WAIT);
    /* an answer the moment the finger lifts: the page on screen starts to ease aside (on the compositor,
       so it keeps moving while the next page is built), and the change carries on from there */
    var now = document.getElementById('MainContent');
    if (now && look(opts.tab).style === 'slide' && !opts.still) now.classList.add('pp-leaving', 'pp-leaving--' + (dir === 'back' ? 'back' : dir === 'next' ? 'next' : 'up'));
    /* from memory: one frame first, so the bar's lens and the page are already moving (on the compositor)
       before the page is built */
    var got = instant ? new Promise(function (res) { requestAnimationFrame(function () { setTimeout(function () { res(c); }, 0); }); }) : load(k, true, true);
    got.then(function (entry) {
      if (my !== turn) return;
      ready(entry);
      if (!safe(entry.doc)) throw new Error('unsafe');
      return styles(entry.doc).then(function () {
        if (my !== turn) return;
        clearTimeout(slow);
        clearTimeout(give);
        waiting(false);
        entry.used = Date.now();
        closeOverlays();
        /* the Back button: a tab rebuilds the steps (Home, then the tab); a link adds one. Done once the
           new page is on its way (swap), never before it */
        var hist = function () {
          if (pop) return;
          if (opts.tab) return rebase(url, opts.home, opts.homeY);
          history.pushState({ ppan: 1 }, '', url);
        };
        swap(entry, dir, y, opts.still, opts.tab, url, function () {
          if (my !== turn) return;
          return Promise.resolve(hist()).then(function () {
            if (instant && Date.now() - entry.t > 1500) refresh(k, entry);
          });
        });
      });
    }).catch(function () {
      clearTimeout(slow);
      clearTimeout(give);
      if (my === turn) fallback(url, pop, opts);
    });
    return true;
  }

  /* an ordinary load after all; a tab in place of the entry shown (not one more step back) unless the
     visit is on its first page */
  function fallback(url, pop, opts) {
    turn++;
    waiting(false);
    if (pop) location.reload();
    else if (opts && opts.tab && depth > 0) { replacing = true; saveDepth(); location.replace(url); }
    else location.href = url;
  }

  /* back / forward (called first, from <head>): true when it was ours */
  function popped(e) {
    var st = history.state;
    var was = depth;
    if (st && typeof st.d === 'number') depth = st.d;
    saveDepth();
    if (ignore) { if (landed) landed(); return true; }
    var k = here();
    if (norm(strip(location.href).pathname) === norm(strip(shown).pathname)) { shown = k; return false; }
    var from = page(shown);
    var to = page(location.href);
    shown = k;
    if (phone.matches && eligible(location.href)) {
      /* the browser's own swipe back (iPhone, Android) has already shown the move: no second one */
      var moved = !!(e && e.hasUAVisualTransition);
      var dir = depth < was ? 'back' : depth > was ? 'next' : (from && to && to.i < from.i ? 'back' : 'next');
      go(location.href, dir, true, undefined, { still: moved });
    } else {
      location.reload();
    }
    return true;
  }

  /* the browser's own scroll restoring for ordinary visits to this page later */
  window.addEventListener('pagehide', function () { try { history.scrollRestoration = 'auto'; } catch (e) {} });
  /* back to this phone after a while: bring the copies up to date, and put back the title of the page
     shown (the theme's "tab message" restores the title the first page had) */
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    if (pages.length) preload();
    var t = cache[shown] && cache[shown].doc && cache[shown].doc.title;
    if (t) setTimeout(function () { document.title = t; }, 0);
  });

  /* what is on screen is fetched ahead once the page has settled */
  (window.requestIdleCallback || function (f) { return setTimeout(f, 1200); })(function () { scout(document); }, { timeout: 3000 });
  window.addEventListener('pagehide', saveDepth);

  window.PPAppNav = {
    /* the bar names its pages: [{ href, i }] */
    pages: function (list) {
      pages = list.map(function (x) { return { path: norm(strip(x.href).pathname), key: key(x.href), i: x.i, cart: !!x.cart }; });
      preload();
    },
    can: function (url) { return !healed && phone.matches && eligible(url); },
    cartChanged: function () {
      cartAt = Date.now();
      var c = pages.filter(function (x) { return x.cart; })[0];
      if (c && cache[c.path] && !cache[c.path].p) delete cache[c.path];
      if (c && !frugal()) setTimeout(function () { if (!cache[c.path]) load(c.path, true).then(function (e) { later(e, warm); }, function () {}); }, 1200);
    },
    /* a finger down on a tab: its stored page is read now, after the press has been drawn, so the tap
       itself has nothing left to read */
    prepare: function (url) {
      if (healed || !phone.matches || !eligible(url)) return;
      var c = cache[key(url)];
      if (!c || c.doc || !c.text) return;
      requestAnimationFrame(function () { setTimeout(function () { try { ready(c); } catch (e) {} }, 0); });
    },
    go: go,
    pop: popped,
    /* the bar loads a tab the ordinary way in place of the page shown */
    replace: function (url) { replacing = true; saveDepth(); location.replace(url); }
  };
})();
